import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useContext,
} from 'react';
import classes from './NewsMainBlockContainer.module.css';
import NewsMainBlock from './NewsMainBlock/NewsMainBlock';
import { Article } from '../../types/api';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addNews } from '../../store/NewsSlice';
import { RootState } from '../../store';
import { useGetNewsForMainQuery } from '../../services/newsService';
import { ThemeContext } from '../../App';

export default function NewsMainBlockContainer() {
  const { data: news, error, isLoading } = useGetNewsForMainQuery();

  const globalNews: Article[] = useSelector((state: RootState) =>
    state.news.news.slice(0, 4),
  );

  const dispatch = useDispatch();

  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    if (news) {
      const fixedNews = news.map((oneNews) => {
        return {
          ...oneNews,
          image: oneNews.image === 'None' ? undefined : oneNews.image,
        };
      });
      dispatch(addNews(fixedNews));
    }
  }, [news, dispatch]);

  return (
    <div id={classes[theme]} className={classes.newsMainBlockContainer}>
      <h3 className={classes.title + ' text-smBtwPages lg:text-lgBtwPages'}>
        Our latest <span>news</span> and insights
      </h3>

      <div
        className={
          classes.newsBlocks +
          ' flex flex-row flex-wrap md:flex-col lg:flex-row '
        }
      >
        {globalNews ? (
          globalNews.map((article) =>
            article.title ? (
              <NewsMainBlock
                key={article.url}
                image={article.image}
                url={article.url}
                title={article.title}
                description={article.description}
                published={article.published}
              />
            ) : null,
          )
        ) : (
          <p className="text-smBigSepTxt md:text-mdBigSepTxt lg:text-lgBigSepTxt">
            Loading...
          </p>
        )}
      </div>
      <Link
        to="/industryNews"
        className={
          classes.viewAllNewsBtn +
          ' text-smSepBtnTxt p-2vh10vw md:text-mdSepBtnTxt lg:text-lgSepBtnTxt lg:p-2vh4vw'
        }
      >
        <p>View all</p>
      </Link>
    </div>
  );
}
